import { render, staticRenderFns } from "./ModalUser.vue?vue&type=template&id=0fc3aca5&scoped=true"
import script from "./ModalUser.vue?vue&type=script&lang=js"
export * from "./ModalUser.vue?vue&type=script&lang=js"
import style0 from "./ModalUser.vue?vue&type=style&index=0&id=0fc3aca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3aca5",
  null
  
)

export default component.exports